import React, { Component, useEffect, useState } from "react";
import { connect } from "react-redux";
import LinearProgress from "@mui/material/LinearProgress";
import { Box, Card, CardContent, CardHeader, Grid, Paper, Typography } from "@mui/material";
import { withStyles } from "@mui/styles";

import instance from "../../axios";
import pieChartDefault from "../../Components/common/Charts/pieChartDefault";
import Select from "react-select";
import moment from "moment";
import Button from "../../Components/common/Button";
import Tooltip from "@mui/material/Tooltip";
import { nFormatter, replaceSpecialCh } from "../../Helpers";
import Skeleton from "@mui/material/Skeleton";
import axios from 'axios'
import { addTabSale10, addTabSale11,addTabSale5, addTabSale6, addTabSale7,addTabSale8, addTabSale9 } from "../../Actions/SaleDashboard";
// import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'react-toastify/dist/ReactToastify.css';
import DashboardCardInfo from "../../Components/common/DashboardCardInfo";
// import { ConsoleWriter } from "istanbul-lib-report";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts/highmaps";
import { Scrollbar } from "react-scrollbars-custom";
import withRoutes from "../../HOC/HocRoutes";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { FiltersOption, MaintenanceItemEmpty } from "../MaintenanceDashboard/MaintenanceDashboard";
import { CollectionOutstandingCard } from "./Dashboard";


const WidgetsNew = (props) => {
    const [state, setState] = useState({
        loader1: false,
        tab1: "",
        tab2: "",
        // ... all tabs
    });
    const logInUser = useSelector((state) => state.logInUsers)
    const tab6 = useSelector((state) => state.tabSale6)
    const tab8 = useSelector((state) => state.tabSale8)
    const tab5 = useSelector((state) => state.tabSale5)
    const tab7 = useSelector((state) => state.tabSale7)
    const tab9 = useSelector((state) => state.tabSale9)
    const tab10 = useSelector((state) => state.tabSale10)
    const tab11 = useSelector((state) => state.tabSale11)
    const dispatch = useDispatch()
    const getToFrom = (value) => {
        let timezone = "";
        if (
            props.logInUser &&
            props.logInUser.attributes &&
            props.logInUser.attributes.timezone
        ) {
            timezone = props.logInUser.attributes.timezone
        } else {
            timezone = "Asia/Riyadh"
        }

        const now = moment().tz(timezone);

        if (value === 1) {
            const startOfMonth = now.clone().startOf("month");
            const endOfMonth = now.clone().endOf("month");

            return {
                from: startOfMonth.toISOString(),
                to: endOfMonth.toISOString(),
            };
        } else if (value === 2) {
            const lastMonthStart = now.clone().subtract(1, "month").startOf("month");
            const lastMonthEnd = now.clone().subtract(1, "month").endOf("month");

            return {
                from: lastMonthStart.toISOString(),
                to: lastMonthEnd.toISOString(),
            };
        } else if (value === 3) {
            const threeMonthsAgo = now.clone().subtract(3, "months");
            const startOfThreeMonthsAgo = threeMonthsAgo.clone().startOf("month");
            const endOfLastMonth = now.clone().subtract(1, "month").endOf("month");

            return {
                from: startOfThreeMonthsAgo.toISOString(),
                to: endOfLastMonth.toISOString(),
            };
        } else if (value === 4) {
            const startOfYear = now.clone().startOf("year");

            return {
                from: startOfYear.toISOString(),
                to: now.toISOString(),
            };
        } else if (value === 6) {
            return {
                from: false,
                to: false,
            };
        } else {
            const lastYearStart = now.clone().subtract(1, "year").startOf("year");
            const lastYearEnd = now.clone().subtract(1, "year").endOf("year");

            return {
                from: lastYearStart.toISOString(),
                to: lastYearEnd.toISOString(),
            };
        }
    };
    const getCMS4 = (to, from, tab1) => {
        setState((prevState) => ({
            ...prevState,
            loader4: tab1 ? false : true, tab1loader5: tab1 ? true : false
        }))
        let url =
            to && from
                ? `/api/dashboards/cms/4?to=${to}&from=${from}&contractType=1&contractType=3&userType=3`
                : `/api/dashboards/cms/4?contractType=1&contractType=3&userType=3`;
        instance({ url: url, method: "GET" })
            .then((res) => {
                let maxUsedCount = Math.max(
                    ...res.clientList.map((item) => item.saleNetAmount)
                );
                let usedPartPercentages = res.clientList.map((item) => {
                    return {
                        ...item,
                        salesPercentage: (item.saleNetAmount / maxUsedCount) * 100,
                    };
                });

                if (tab1) {
                    setState((prevState) => ({
                        ...prevState,
                        loader4: false,
                        tab1loader5: false,
                        salesClientsTab1: res.totalSaleTotalAmount,
                        salesClients1: {
                            ...res,
                            clientList: usedPartPercentages,
                        }
                    }))

                } else {
                    setState((prevState) => ({
                        ...prevState,
                        tab1loader5: false,

                        salesClients: {
                            ...res,
                            clientList: usedPartPercentages,
                        },
                        loader4: false,
                    }))
                }
                let dat = {
                    res: res,
                    initFetch: true,

                }
                // props.dispatch(addTab5(dat)); 

            })
            .catch((err) => { });

    };
    const getDashboardData = (from, to, startOfMonth, endOfMonth, lastYearStart, lastYearEnd) => {
        let tab1Data = {}
        setState((prevState) => ({
            ...prevState,
            loaderA1: true,
            tab1loader3: true
        }))
        setState((prevState) => ({
            ...prevState,
            loader5: true
        }))


        if (tab6 && tab6.initFetch) {
            setState((prevState) => ({
                ...prevState,
                loader5: false,
                totalFleetSize: tab6.totalFleetSize || 0,
                clientVehiclesVehicleWise: tab6.clientVehiclesVehicleWise || [],
            }))
        }
        else {
            instance({ url: `/api/dashboards/cms/2?contractType=1&contractType=3&userType=3`, method: "GET" })
                .then((res) => {

                    let makeData = [];
                    let colors = [
                        "#da5e5e",
                        "#f50057",
                        "#7b101b",
                        "#00c179",
                        "#d52f2f",
                        "#ec1c91",
                        "#28a788",
                        "#3f52b5e6",
                        "#594a86",
                        "#864a73",
                    ];
let maxUsedCount = Math.max(
  ...res.data.map((item) => item.accessVehiclesCount)
);
let dtRes = [...res.data].sort((a, b) => b.accessVehiclesCount - a.accessVehiclesCount);
let usedPartPercentages = dtRes.map((item) => {
  return {
    ...item,
    salesPercentage: (item.accessVehiclesCount / maxUsedCount) * 100,
  };
});
                    setState((prevState) => ({
                        ...prevState,
                        loader5: false,
                        totalFleetSize: res.totalFleetCount,
                        clientVehiclesVehicleWise: usedPartPercentages,
                    }))

                    let dt = {
                        initFetch: true,
                        totalFleetSize: res.totalFleetCount,
                        clientVehiclesVehicleWise: usedPartPercentages
                    }
                    dispatch(addTabSale6(dt))
                })
                .catch((err) => { });

        }
        setState((prevState) => ({
            ...prevState,
            loader7: true, tab1loader1: true
        }))
        if (tab8 && tab8.initFetch) {
            setState((prevState) => ({
                ...prevState,
                loader7: false,
                tab1loader1: false,
                maintRequestClientWise: {
                    clientList: tab8.maintRequestClientWise.clientList,
                    totalInvoicesCount: tab8.maintRequestClientWise?.totalInvoicesCount || 0,
                },
                maintRequestClientWiseTab1: tab8.maintRequestClientWiseTab1 || 1,
            }))

        }
        else {
            instance({ url: `/api/dashboards/cms/3?contractType=1&contractType=3&userType=3`, method: "GET" })
                .then((res) => {
                    let maxUsedCount = Math.max(
                        ...res.clientList.map((item) => item.count)
                    );
                    let usedPartPercentages =
                        res.clientList &&
                        res.clientList.map((item) => {
                            return {
                                ...item,
                                countPercentage: (item.count / maxUsedCount) * 100,
                            };
                        });
                    setState((prevState) => ({
                        ...prevState,
                        loader7: false,
                        tab1loader1: false,
                        maintRequestClientWise: {
                            clientList: usedPartPercentages,
                            totalInvoicesCount: res?.totalInvoicesCount || 0,
                        },
                        maintRequestClientWiseTab1: res?.totalDeliveryNotesCount || 1,
                    }))


                    let dat = {
                        initFetch: true,
                        maintRequestClientWise: {
                            clientList: usedPartPercentages,
                            totalInvoicesCount: res?.totalInvoicesCount || 0,
                        },
                        maintRequestClientWiseTab1: res?.totalDeliveryNotesCount || 1,
                    }
                    dispatch(addTabSale8(dat));

                })
                .catch((err) => {
                    console.error("err 3 ====", err);
                });
        }
        setState((prevState) => ({
            ...prevState,
            loader4: true,
            tab1loader5: true
        }))

        if (tab5 && tab5.initFetch) {
            let res = tab5.res || {}
            let maxUsedCount = Math.max(
                ...res.clientList.map((item) => item.saleNetAmount)
            );
            let usedPartPercentages = res.clientList.map((item) => {
                return {
                    ...item,
                    salesPercentage: (item.saleNetAmount / maxUsedCount) * 100,
                };
            });
            setState((prevState) => ({
                ...prevState,
                loader4: false,
                tab1loader5: false,
                salesClientsTab1: res?.totalSaleTotalAmount || 0,
                salesClients: {
                    ...res,
                    clientList: usedPartPercentages,
                },
                salesClients1: {
                    ...res,
                    clientList: usedPartPercentages,
                },
            }))

        }
        else {
            instance({ url: `/api/dashboards/cms/4?contractType=1&contractType=3&userType=3`, method: "GET" })
                .then((res) => {
                    let maxUsedCount = Math.max(
                        ...res.clientList.map((item) => item.saleNetAmount)
                    );
                    let usedPartPercentages = res.clientList.map((item) => {
                        return {
                            ...item,
                            salesPercentage: (item.saleNetAmount / maxUsedCount) * 100,
                        };
                    });
                    setState((prevState) => ({
                        ...prevState,
                        loader4: false,
                        tab1loader5: false,

                        salesClientsTab1: res?.totalSaleTotalAmount || 0,
                        salesClients: {
                            ...res,
                            clientList: usedPartPercentages,
                        },
                        salesClients1: {
                            ...res,
                            clientList: usedPartPercentages,
                        },
                    }))

                    let dat = {
                        res: res,
                        initFetch: true
                    }
                    dispatch(addTabSale5(dat));
                })
                .catch((err) => { })

        }

        setState((prevState) => ({
            ...prevState,
            loader6: true, tab1loader4: true
        }))

        if (tab7 && tab7.initFetch) {
            setState((prevState) => ({
                ...prevState,
                loader6: false,
                tab1loader4: false,
                salesClientsWise: {
                    ...tab7.salesClientsWise,
                    clientList: tab7.salesClientsWise.clientList,
                },
                totalOurDue: tab7?.totalOurDue || 0,
            }))

        }
        else {
            instance({ url: `/api/dashboards/cms/5?contractType=1&contractType=3&userType=3`, method: "GET" })
                .then((res1) => {
                    let res = res1.clientList.reverse();
                    let maxUsedCount = Math.max(
                        ...res.map((item) => item.overDue)
                    );
                    let usedPartPercentages = res.map((item) => {
                        return {
                            ...item,
                            ourDuePercentage:
                                (item.overDue / maxUsedCount) * 100,
                        };
                    });
                    setState((prevState) => ({
                        ...prevState,
                        loader6: false,
                        tab1loader4: false,

                        salesClientsWise: {
                            ...res1,
                            clientList: usedPartPercentages,
                        },
                        totalOurDue: res1?.totalOurDue || 0,
                    }))
                    let dt = {
                        initFetch: true,
                        salesClientsWise: {
                            ...res1,
                            clientList: usedPartPercentages,
                        },
                        totalOurDue: res1?.totalOurDue || 0,
                    }
                    dispatch(addTabSale7(dt))
                })
                .catch((err) => {
                    console.error("err 5====", err);
                });
        }


        setState((prevState) => ({
            ...prevState,
            loader10: true
        }))

        setState((prevState) => ({
            ...prevState,
            loader8: true
        }))

        if (tab9 && tab9.initFetch) {
            setState((prevState) => ({
                ...prevState,
                loader8: false,
                usedPart: tab9.data
            }))

        }
        else {
            instance({ url: `/api/dashboards/cms/8?contractType=1&contractType=3&userType=3`, method: "GET" })
                .then((res) => {
                    let maxUsedCount = Math.max(...res.map((item) => item.usedCount));
                    let usedPartPercentages = res.map((item) => {
                        return {
                            ...item,
                            usedCountPercentage: (item.usedCount / maxUsedCount) * 100,
                        };
                    });
                    setState((prevState) => ({
                        ...prevState,
                        loader8: false,
                        usedPart: usedPartPercentages
                    }))

                    let dt = {
                        data: usedPartPercentages,
                        initFetch: true
                    }
                    dispatch(addTabSale9(dt))
                })
                .catch((err) => {
                    console.log("err 8====", err);
                });
        }

        setState((prevState) => ({
            ...prevState,
            loader13: true
        }))

        if (tab10 && tab10.initFetch) {
            setState((prevState) => ({
                ...prevState,
                loader13: false,
                usedService: tab10.data
            }))

        }
        else {
            instance({ url: `/api/dashboards/cms/9?contractType=1&contractType=3&userType=3`, method: "GET" })
                .then((res) => {
                    let maxUsedCount = Math.max(...res.map((item) => item.usedCount));
                    let usedPartPercentages = res.map((item) => {
                        return {
                            ...item,
                            usedCountPercentage: (item.usedCount / maxUsedCount) * 100,
                        };
                    });
                    setState((prevState) => ({
                        ...prevState,
                        loader13: false,
                        usedService: usedPartPercentages
                    }))

                    let dt = {
                        initFetch: true,
                        data: usedPartPercentages
                    }
                    dispatch(addTabSale10(dt))
                })
                .catch((err) => {
                    console.log("err 9====", err);
                });
        }

        setState((prevState) => ({
            ...prevState,
            loader14: true
        }))

        if (tab11 && tab11.initFetch) {
            setState((prevState) => ({
                ...prevState,
                loader14: false,
                usedPackages: tab11.data
            }))

        }
        else {
            instance({ url: `/api/dashboards/cms/10?contractType=1&contractType=3&userType=3`, method: "GET" })
                .then((res) => {
                    let maxUsedCount = Math.max(...res.map((item) => item.usedCount));
                    let usedPartPercentages = res.map((item) => {
                        return {
                            ...item,
                            usedCountPercentage: (item.usedCount / maxUsedCount) * 100,
                        };
                    });
                    setState((prevState) => ({
                        ...prevState,
                        loader14: false,
                        usedPackages: usedPartPercentages
                    }))

                    let dt = {
                        initFetch: true,
                        data: usedPartPercentages
                    }
                    dispatch(addTabSale11(dt))
                })
                .catch((err) => {
                    console.log("err 10====", err);
                });
        }

        setState((prevState) => ({
            ...prevState,
            loader9: true
        }))


        setState((prevState) => ({
            ...prevState,
            loader11: true
        }))

    };
    const getCMS2 = (to, from) => {
        setState((prevState) => ({
            ...prevState,
            loader5: true
        }))

        let url =
            to && from
                ? `/api/dashboards/cms/2?to=${to}&from=${from}&contractType=1&contractType=3&userType=3`
                : `/api/dashboards/cms/2?contractType=1&contractType=3&userType=3`;
        instance({ url: url, method: "GET" })
            .then((res) => {
                let makeData = [];
                let colors = [
                    "#da5e5e",
                    "#f50057",
                    "#7b101b",
                    "#00c179",
                    "#d52f2f",
                    "#ec1c91",
                    "#28a788",
                    "#3f52b5e6",
                    "#594a86",
                    "#864a73",
                ];

                res &&
                    res.data.map((item, index) => {
                        makeData.push({
                            name: item.contractNumber,
                            key: item.accessVehiclesCount,
                            y: item.accessVehiclesCount,
                            color: colors[index],
                        });
                    });
                let makeData2 = [{ data: makeData }];
                setState((prevState) => ({
                    ...prevState,
                    totalFleetSize: res.totalFleetCount, clientVehiclesVehicleWise: res.data, loader5: false
                }))

                let dt = {
                    initFetch: true,
                    clientVehiclesVehicleWise: res.data,
                    totalFleetSize: res.totalFleetCount
                }
                dispatch(addTabSale6(dt))
            })
            .catch((err) => { });

    };
    const getCMS3 = (to, from, chk) => {
        setState((prevState) => ({
            ...prevState,
            loader7: chk ? false : true, tab1loader1: chk ? true : false,
        }))
        let url =
            to && from
                ? `/api/dashboards/cms/3?to=${to}&from=${from}&contractType=1&contractType=3&userType=3`
                : `/api/dashboards/cms/3?contractType=1&contractType=3&userType=3`;
        instance({ url: url, method: "GET" })
            .then((res) => {
                if (chk) {
                    setState((prevState) => ({
                        ...prevState,
                        maintRequestClientWiseTab1: res?.totalDeliveryNotesCount || 1,
                        loader7: false,
                        tab1loader1: false
                    }))

                } else {
                    let maxUsedCount = Math.max(
                        ...res.clientList.map((item) => item.count)
                    );
                    let usedPartPercentages =
                        res.clientList &&
                        res.clientList.map((item) => {
                            return {
                                ...item,
                                countPercentage: (item.count / maxUsedCount) * 100,
                            };
                        });
                    setState((prevState) => ({
                        ...prevState,
                        loader7: false,
                        tab1loader1: false,

                        maintRequestClientWise: {
                            clientList: usedPartPercentages,
                            totalInvoicesCount: res?.totalInvoicesCount || 0,
                        },
                    }))

                    let dat = {
                        initFetch: true,
                        maintRequestClientWise: {
                            clientList: usedPartPercentages,
                            totalInvoicesCount: res?.totalInvoicesCount || 0,
                        },
                        maintRequestClientWiseTab1: res?.totalDeliveryNotesCount || 1,
                    }
                    // this.props.dispatch(addTab8(dat));
                }
            })
            .catch((err) => {
                console.log("err 3 ====", err);
            });
    };
    const getCMS5 = (to, from, chk) => {
        setState((prevState) => ({
            ...prevState,
            loader6: chk ? false : true, tab1loader4: chk ? true : false,

        }))

        let url =
            to && from
                ? `/api/dashboards/cms/5?to=${to}&from=${from}&contractType=1&contractType=3&userType=3`
                : `/api/dashboards/cms/5?contractType=1&contractType=3&userType=3`;
        instance({ url: url, method: "GET" })
            .then((res1) => {
                if (chk) {
                    setState((prevState) => ({
                        ...prevState,
                        totalOurDue: res1?.totalOurDue,
                        loader6: false,
                        tab1loader4: false

                    }))

                } else {
                    let res = res1.clientList.reverse();

                    // let maxUsedCount = Math.max(...res.clientList?.map(item => item.outstandingBalance));
                    let maxUsedCount = Math.max(
                        ...res?.map((item) => item.overDue)
                    );
                    // let usedPartPercentages = res.clientList.map(item => {
                    //   return {  ...item, ourDuePercentage: (item.overDue / maxUsedCount) * 100
                    //   }
                    // })
                    let usedPartPercentages = res?.map((item) => {
                        return {
                            ...item,
                            ourDuePercentage:
                                (item.overDue / maxUsedCount) * 100,
                        };
                    });
                    setState((prevState) => ({
                        ...prevState,
                        salesClientsWise: {
                            ...res,
                            clientList: usedPartPercentages,
                        },
                        loader6: false,
                        tab1loader4: false

                    }))

                    let dt = {
                        initFetch: true,
                        salesClientsWise: {
                            ...res,
                            clientList: usedPartPercentages,
                        },
                        totalOurDue: res?.totalOurDue || 0,
                    }
                    // this.props.dispatch(addTab7(dt))
                }
            })
            .catch((err) => {
                console.log("err 5====", err);
            });

    };
    const getCMS8 = (to, from) => {
        setState((prevState) => ({
            ...prevState,
            loader8: true
        }))
        let url =
            to && from
                ? `/api/dashboards/cms/8?to=${to}&from=${from}&contractType=1&contractType=3&userType=3`
                : `/api/dashboards/cms/8?contractType=1&contractType=3&userType=3`;
        instance({ url: url, method: "GET" })
            .then((res) => {
                let maxUsedCount = Math.max(...res.map((item) => item.usedCount));
                let usedPartPercentages = res.map((item) => {
                    return {
                        ...item,
                        usedCountPercentage: (item.usedCount / maxUsedCount) * 100,
                    };
                });
                setState((prevState) => ({
                    ...prevState,
                    usedPart: usedPartPercentages, loader8: false
                }))
                let dt = {
                    data: usedPartPercentages,
                    initFetch: true
                }
                dispatch(addTabSale9(dt))
            })
            .catch((err) => {
                console.log("err 8====", err);
            });
    };
    const getCMS9 = (to, from) => {
        setState((prevState) => ({
            ...prevState,
            loader13: true
        }))

        let url =
            to && from
                ? `/api/dashboards/cms/9?to=${to}&from=${from}&contractType=1&contractType=3&userType=3`
                : `/api/dashboards/cms/9?contractType=1&contractType=3&userType=3`;
        instance({ url: url, method: "GET" })
            .then((res) => {
                let maxUsedCount = Math.max(...res.map((item) => item.usedCount));
                let usedPartPercentages = res.map((item) => {
                    return {
                        ...item,
                        usedCountPercentage: (item.usedCount / maxUsedCount) * 100,
                    };
                });
                setState((prevState) => ({
                    ...prevState,
                    usedService: usedPartPercentages, loader13: false
                }))

                let dt = {
                    initFetch: true,
                    data: usedPartPercentages
                }
                dispatch(addTabSale10(dt))
            })
            .catch((err) => {
                console.log("err 9====", err);
            });
    };
    const getCMS10 = (to, from) => {
        setState((prevState) => ({
            ...prevState,
            loader14: true
        }))

        let url =
            to && from
                ? `/api/dashboards/cms/10?to=${to}&from=${from}&contractType=1&contractType=3&userType=3`
                : `/api/dashboards/cms/10?contractType=1&contractType=3&userType=3`;
        instance({ url: url, method: "GET" })
            .then((res) => {
                // let res = res1.clientList;
                let maxUsedCount = Math.max(...res?.map((item) => item.usedCount));
                let usedPartPercentages = res.map((item) => {
                    return {
                        ...item,
                        usedCountPercentage: (item.usedCount / maxUsedCount) * 100,
                    };
                });
                setState((prevState) => ({
                    ...prevState,
                    usedPackages: usedPartPercentages, loader14: false
                }))

                let dt = {
                    initFetch: true,
                    data: usedPartPercentages
                }
                dispatch(addTabSale11(dt))
            })
            .catch((err) => {
                console.error("err 10====", err);
            });
    };
    const handleChange = async (name, e) => {
        if (name === "tab1") {
            setState(prevState => ({
                ...prevState,
                loader1: true
            }));
        }

        setState(prevState => ({
            ...prevState,
            [name]: e.label,
            loader1: name === "tab1" ? true : prevState.loader1
        }));

        const res = await getToFrom(e.value);

        if (name === "tab1") {
            await Promise.all([
                getCMS5(res.to, res.from, true),
                getCMS4(res.to, res.from, true),
                getCMS3(res.to, res.from, true),
            ]);
            setState(prevState => ({
                ...prevState,
                loader1: false
            }));
        } else if (name === "tab5") {
            getCMS4(res.to, res.from);
        } else if (name === "tab6") {
            getCMS2(res.to, res.from);
        } else if (name === "tab7") {
            getCMS5(res.to, res.from);
        } else if (name === "tab8") {
            getCMS3(res.to, res.from);
        } else if (name === "tab9") {
            getCMS8(res.to, res.from);
        } else if (name === "tab10") {
            getCMS9(res.to, res.from);
        } else if (name === "tab11") {
            getCMS10(res.to, res.from);
        } else {
            getCMS10(res.to, res.from);
        }
    };

    

    const openVehicle = (item) => {
        let dt = [];
        let ind = 0;
        let colors = [
            "#28A745",
            "#e86493",
            "#f6cc4e",
            "#EAEAEA",
            "#d52f2f",
            "#5d2c2c",
            "#45e6aa",
            "#427ace",
            "#477ac7",
            "#c747b5",
        ];
        for (const [key, value] of Object.entries(item.categoryCount)) {
            dt.push({
                name: key,
                y: value,
                value: value,
                formattedvalue: value,
                color: colors[ind++],
            });
        }
        let selectedData = [{ data: dt }];
        setState((prevState) => ({
            ...prevState,
            openGraph: true, selectedVehicle: selectedData
        }))

    };
    const CloseGraph = () => {
        setState((prevState) => ({
            ...prevState,
            openGraph: false, selectedVehicle: {}
        }))
    };
    useEffect(() => {
        let timezone = "Asia/Riyadh";

        if (
            logInUser &&
            logInUser.attributes &&
            logInUser.attributes.timezone
        ) {
            timezone = logInUser.attributes.timezone;
        }

        const now = moment().tz(timezone);

        // ======== dashboards/cms/16 - YTD (Year to Date) =========
        const startOfYear = now.clone().startOf("year");
        const endOfDay = now.clone().endOf("day");

        // ======== dashboards/cms/16 - MTD (Month to Date) =========
        const startOfMonth = now.clone().startOf("month");
        const endOfMonth = now.clone().endOf("month");

        // ======== Last year same period =========
        const lastYearStart = startOfYear.clone().subtract(1, "year");
        const lastYearEnd = endOfDay.clone().subtract(1, "year");

        getDashboardData(
            startOfYear.toISOString(),
            endOfDay.toISOString(),
            startOfMonth.toISOString(),
            endOfMonth.toISOString(),
            lastYearStart.toISOString(),
            lastYearEnd.toISOString()
        );
    }, []); // Only runs once on mount

    let clientVehiclesVehicleWiseChart = {
        config: pieChartDefault().initializeWithOptions({
            chart: {
                height: "310px",
            },
            // title: {
            //   text: "table.head"
            // },
            plotOptions: {
                series: {
                    dataLabels: {
                        enabled: false,
                        format: "{point.name}: {point.y:.1f}",
                        style: {
                            fontWeight: "bold",
                            color: "currentColor",
                        },
                    },
                },
            },
            series: state.selectedVehicle,
            legend: {
                enabled: true,
            },
            yAxis: {
                gridLineWidth: 0,
            },
            tooltip: {
                formatter: function () {
                    return (
                        "<strong>" +
                        this.key +
                        "</strong>" +
                        " <br>" +
                        "<strong>" +
                        this.y.toFixed(2) +
                        "</strong>"
                    );
                },
            },
        }),
        show: true,
    };
    return (

        <div>
            <Grid
                container
                spacing={2}
                mt={2}
            >
                {renderClientColumn({
                    title: props.translate("clientSales"),
                    subtitle: "SAR",
                    selectOptions: props.FiltersOptionWithoutMTD,
                    selectedOption: state.tab5,
                    onChange: (e) => handleChange("tab5", e),
                    dataList: state.salesClients?.clientList,
                    valueKey: "saleNetAmount",
                    percentageKey: "salesPercentage",
                    progressClass: "success",
                    isLoading: state.loader4,
                    tooltipTitle:"Total Sales Per Account (w/o Vat)"
                })}

                {renderClientColumn({
                    title: props.translate("clientVehiclesCount"),
                    dataList: state.clientVehiclesVehicleWise,
                    valueKey: "accessVehiclesCount",
                    percentageKey: "salesPercentage",
                    progressClass: "light-green",
                    isLoading: state.loader5,
                    onClickItem: openVehicle,
                    showChart: state.openGraph,
                    chartConfig: clientVehiclesVehicleWiseChart?.config,
                    onBack: CloseGraph,
                    subtitle: state.totalFleetSize ? `(${nFormatter(state.totalFleetSize, 2)})` : "(0)",
                    tooltipTitle:"Total Vehicles Per Account"
                })}

                {renderClientColumn({
                    title: props.translate("clientOutstanding"),
                    subtitle: "SAR",
                    selectOptions: props.FiltersOption,
                    selectedOption: state.tab7,
                    onChange: null,
                    dataList: state.salesClientsWise?.clientList,
                    valueKey: "overDue",
                    percentageKey: "ourDuePercentage",
                    progressClass: "purple",
                    isLoading: state.loader6,
                    tooltipTitle:"Total Overdue Amount Per Account"
                })}

                {renderClientColumn({
                    title: props.translate("clientMaint.InvoiceCount"),
                    selectOptions: props.FiltersOption,
                    selectedOption: state.tab8,
                    onChange: (e) => handleChange("tab8", e),
                    dataList: state.maintRequestClientWise?.clientList,
                    valueKey: "count",
                    percentageKey: "countPercentage",
                    progressClass: "danger",
                    isLoading: state.loader7,
                    tooltipTitle:"Total DNs Count Per Account"
                })}
            </Grid>
            <Grid
                container
                spacing={2}
                mt={2}
                // xs={12}
                // sm={12}
                // md={12}
                // lg={12}
                mb={5}
            >
                {renderColumn({
                    isLoading: state.loader8,
                    title: "topParts",
                    selectValue: state.tab9,
                    selectKey: "tab9",
                    data: state.usedPart,
                    colorClass: "light-yellow",
                    handleChange,
                    translate: props.translate,
                    xs: state.xs,
                    borderRight: true,
                    borderTop: false,
                    tooltipTitle:"Top Sold Items And Its Count"
                })}
                {renderColumn({
                    isLoading: state.loader13,
                    title: "topServices",
                    selectValue: state.tab10,
                    selectKey: "tab10",
                    data: state.usedService,
                    colorClass: "light-red",
                    handleChange,
                    translate: props.translate,
                    xs: state.xs,
                    borderRight: true,
                    borderTop: true,
                    tooltipTitle:"Top Sold Services And Its Count"
                })}
                {renderColumn({
                    isLoading: state.loader14,
                    title: "topPackages",
                    selectValue: state.tab11,
                    selectKey: "tab11",
                    data: state.usedPackages,
                    colorClass: "light-green",
                    handleChange,
                    translate: props.translate,
                    xs: state.xs,
                    borderRight: false,
                    borderTop: true,
                    tooltipTitle:"Top Sold Packages And Its Count"
                })}

                <CollectionOutstandingCard loader={props.collectsLoading} data={props.collectionsAndOutStandingData}/>

            </Grid>

        </div>
    )
}
    ;

function renderClientColumn({
    title,
    subtitle,
    selectOptions,
    selectedOption,
    onChange,
    dataList,
    progressClass,
    valueKey,
    percentageKey,
    isLoading,
    tooltipFormatter,
    onClickItem,
    chartConfig,
    showChart,
    onBack,
    tooltipTitle
}) {
    return (
        <Grid item xs={12} sm={6} md={3} lg={3}>
            <Paper elevation={3} sx={{ borderRadius: 2, position: "relative", height: "100%" }}>
                {isLoading ? (
                    <Box p={2}>
                        <MaintenanceItemEmpty />
                    </Box>
                ) : (
                    <>
                        <Box
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                            px={2}
                            pt={2}
                            pb={0}
                        >
                            <Typography variant="subtitle1" fontWeight={700}>
                                {title}
                                {subtitle && (
                                    <Typography
                                        component="span"
                                        variant="caption"
                                        fontWeight={500}
                                        sx={{ ml: 0.5 }}
                                    >
                                        {subtitle}
                                    </Typography>
                                )}
                            </Typography>

                            {selectOptions && (
                                <Select
                                    options={selectOptions}
                                    isDisabled={!onChange}
                                    value={{ label: selectedOption || 'Select' }}
                                    onChange={onChange}
                                    styles={{
                                        container: (base) => ({ ...base, width: 130 }),
                                    }}
                                />
                            )}
                        </Box>

                        <Box px={2} pb={2} pt={1}>
                            {showChart && chartConfig ? (
                                <>
                                    <Box textAlign="end" mt={1}>
                                        <Button size="small" color="inherit" onClick={onBack}>
                                            Back
                                        </Button>
                                    </Box>
                                    <Box mt={1}>
                                        <HighchartsReact highcharts={Highcharts} options={chartConfig} />
                                    </Box>
                                </>
                            ) : (
                                <Scrollbar
                                    disableTracksWidthCompensation
                                    style={{ height: '320px' }}
                                    scrollerProps={{
                                        renderer: ({ elementRef, ...rest }) => (
                                            <div {...rest} ref={elementRef} id="scrollableDiv" />
                                        ),
                                    }}
                                >
                                    <ul className="md-bar-graphlist" style={{ margin: 0, padding: 0 }}>
                                        {dataList?.map((d, i) => (
                                            <li
                                                key={i}
                                                onClick={() => onClickItem?.(d)}
                                                style={{
                                                    cursor: onClickItem ? 'pointer' : 'default',
                                                    marginBottom: 10,
                                                }}
                                            >
                                                <Box
                                                    display="flex"
                                                    justifyContent="space-between"
                                                    height={17}
                                                    overflow="hidden"
                                                >
                                                    <Tooltip
                                                        title={
                                                            <Typography style={{ fontSize: 12 }}>{d.contractName}</Typography>
                                                        }
                                                        enterDelay={300}
                                                    >
                                                        <span
                                                            style={{
                                                                maxWidth: '170px',
                                                                overflow: 'hidden',
                                                                textOverflow: 'ellipsis',
                                                                whiteSpace: 'nowrap',
                                                            }}
                                                        >
                                                            {d.contractName}
                                                        </span>
                                                    </Tooltip>
                                                    <span>
                                                        {(() => {
                                                            try {
                                                                const amount = d[valueKey];
                                                                const integerAmount = Math.floor(amount);
                                                                return integerAmount.toLocaleString();
                                                            } catch (e) {
                                                                return 'Error';
                                                            }
                                                        })()}
                                                    </span>
                                                </Box>
                                                <LinearProgress
                                                    sx={{
                                                        height: 15,
                                                        borderRadius: 0,
                                                        '& .MuiLinearProgress-bar': {
                                                            borderRadius: 0,
                                                        },
                                                        '&.MuiLinearProgress-root.MuiLinearProgress-determinate': {
                                                            borderRadius: 0
                                                        }
                                                    }}
                                                    className={progressClass}
                                                    variant="determinate"
                                                    value={parseInt(d[percentageKey])}
                                                />
                                            </li>
                                        ))}
                                    </ul>
                                </Scrollbar>
                            )}
                        </Box>
                        <DashboardCardInfo title={`${tooltipTitle&&tooltipTitle}`}/>
                    </>
                )}
            </Paper>
        </Grid>

    );
}



const renderDataList = (data, colorClass) => (
    <ul className="md-bar-graphlist" style={{ margin: 0, padding: 0 }}>
        {data?.map((item, idx) => (
            <li key={idx}>
                <Box display="flex" justifyContent="space-between" className="row-label">
                    <em>
                        {item?.itemName || item?.name || ""} - {item?.itemCode || ""}
                    </em>
                    <strong>{item?.usedCount?.toLocaleString() || ""}</strong>
                </Box>
                <LinearProgress
                    style={{ height: 15 }}
                    className={colorClass}
                    variant="determinate"
                    value={item.usedCountPercentage}
                />
            </li>
        ))}
    </ul>
);

const renderColumn = ({
    isLoading,
    title,
    selectValue,
    selectKey,
    data,
    colorClass,
    handleChange,
    translate,
    xs,
    borderRight,
    borderTop,
}) => (
    <Grid
        item
        xs={12}
       sm={6}
        md={3}
        lg={3}
    >
        <Paper
            elevation={3}
            sx={{
                p: 1,
                height: "100%",
                borderRadius: 2,
                position: "relative",
            }}
        >
            {isLoading ? (
                <MaintenanceItemEmpty />
            ) : (
                <>
                    <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        sx={{ mb: 2 }}
                    >
                        <Typography sx={{ fontWeight: 700, fontSize: 14 }}>
                            {translate(title)}
                        </Typography>
                        <Box width={130}>
                            <Select
                                options={FiltersOption}
                                value={{ label: selectValue || "Select" }}
                                onChange={(e) => handleChange(selectKey, e)}
                            />
                        </Box>
                    </Box>

                    <Scrollbar
                        disableTracksWidthCompensation
                        style={{ height: "380px" }}
                        scrollerProps={{
                            renderer: ({ elementRef, ...rest }) => (
                                <div {...rest} ref={elementRef} id="scrollableDiv" />
                            ),
                        }}
                    >
                        {renderDataList(data, colorClass)}
                    </Scrollbar>
                    <DashboardCardInfo title={`${translate(title)} Formula`}/>
                </>
            )}
        </Paper>
    </Grid>
);






export default WidgetsNew